import React, { useEffect, useState } from "react";
import axios from "axios";

const Enquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEnquiries = async () => {
      try {
        const response = await axios.get("https://3esolarventures.com/backend/get_quotes.php");
        if (Array.isArray(response.data)) {
          setEnquiries(response.data);
        } else {
          setEnquiries([]);
          console.error("Unexpected response:", response.data);
        }
      } catch (error) {
        console.error("Error fetching enquiries:", error);
        setEnquiries([]);
      }
      setLoading(false);
    };

    fetchEnquiries();
  }, []);

  return (
    <div className="container mx-auto p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Enquiries</h1>
        
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="bg-white rounded-lg shadow p-6 space-y-4">
                <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse"></div>
              </div>
            ))}
          </div>
        ) : enquiries.length === 0 ? (
          <div className="flex items-center justify-center h-64">
            <div className="text-center text-gray-500">
              <div className="text-6xl mb-4">📄</div>
              <h2 className="text-xl font-semibold">No enquiries found</h2>
              <p className="text-sm">Your enquiries will appear here</p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {enquiries.map((enquiry) => (
              <div
                key={enquiry.id}
                className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 p-6"
              >
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">ID #{enquiry.id}</h3>
                    <p className="text-sm text-gray-600">Created: {new Date(enquiry.created_at).toLocaleDateString()}</p>
                  </div>
                  <span className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-medium">
                    New
                  </span>
                </div>

                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Name:</span>
                    <span className="font-medium text-gray-800">{enquiry.name}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Mobile:</span>
                    <span className="font-medium text-gray-800">{enquiry.mobile_number}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Consumer No:</span>
                    <span className="font-medium text-gray-800">{enquiry.consumer_number}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Email:</span>
                    <span className="font-medium text-gray-800 break-all">{enquiry.email || "N/A"}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">City:</span>
                    <span className="font-medium text-gray-800">{enquiry.city}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Monthly Bill:</span>
                    <span className="font-medium text-gray-800">₹{parseFloat(enquiry.monthly_bill).toFixed(2)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Enquiries;
